import type { RequestOptions } from "ls/api/common/server";
import type {
  LoginAnonymousRequestModel,
  LoginTokenRequestModel,
  SendFeedbackModel,
  UserSessionResponse,
} from "./user.types";
import { objectToFormData } from "@/services/utils/formData";
import { server } from "./server";

export async function loginToken(model: LoginTokenRequestModel, { signal }: RequestOptions = {}) {
  const response = await server.post("user/login-token", { json: model, signal });
  return await response.json() as UserSessionResponse;
}

export async function loginAnonymous(model: LoginAnonymousRequestModel, { signal }: RequestOptions = {}) {
  await server.post("user/login-anonymous", { json: model, signal }).json();
}

export async function textServiceToken({ signal }: RequestOptions = {}) {
  const response = await server.post("user/text-service-token", { signal });
  return await response.json() as string;
}

export async function logout() {
  await server.post("user/logout", undefined).json();
}

export function sendFeedback(model: SendFeedbackModel) {
  const formData = objectToFormData(model);
  return server.post("user/send-feedback", { body: formData }).json();
}
